import React from "react";
import ReactLoading from "react-loading";
import { BRAND_LOADER_COLOR } from "../AppConstants";

interface IProps {
}

export class Spinner extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    render() {
        return (
            <ReactLoading type={"spin"} color={BRAND_LOADER_COLOR} height={"40px"} width={"40px"} />
        );
    }
}

export default Spinner;
